import { createContext, useContext } from 'react';

/**
 * Which look the enclosing `FormItem` uses. Lives apart from `form.tsx` so
 * leaf controls (Input, PhoneInput) can size themselves to the web-form
 * `field` look without importing react-hook-form.
 */
export type FormItemVariant = 'default' | 'field';
export const FormItemVariantContext = createContext<FormItemVariant>('default');
export function useFormItemVariant() {
  return useContext(FormItemVariantContext);
}